'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _reactRedux = require('react-redux');

var _uiTranslations = require('@wh/ui-translations');

var _accountRecovery = require('./account-recovery');

var _accountRecovery2 = _interopRequireDefault(_accountRecovery);

var _actions = require('../login-component/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapDispatchToProps = {
    trackingEvent: _actions.trackingEvent,
    accountRecoveryClicked: _actions.accountRecoveryClicked
};

exports.default = (0, _reactRedux.connect)(null, mapDispatchToProps)((0, _uiTranslations.withTranslator)(_accountRecovery2.default));
//# sourceMappingURL=Container.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/login-component/dist/main/account-recovery/Container.js
// module id = 472
// module chunks = 0